import { useLocation, useNavigate } from "react-router";

import { Icon } from "simplydo/react/ui";

import { TooltipButton } from "components/lib/UI";

import type { IdeaWithOwnerChallenge } from "../types";

type ScrollToCommentsActionProps = { idea: IdeaWithOwnerChallenge };

const ScrollToCommentsAction = ({ idea }: ScrollToCommentsActionProps) => {
  const navigate = useNavigate();
  const location = useLocation();

  if (idea?.ownerChallenge?.preventIdeaComments) {
    return null;
  }

  return (
    <TooltipButton
      icon
      tooltip={"Scroll to comments"}
      style={{ position: "relative" }}
      onClick={() => {
        navigate(location.search + "#comments");
      }}
    >
      <Icon name="comment" />
      {idea.commentCount ?
        <div
          style={{
            position: "absolute",
            right: 3,
            bottom: 0,
            opacity: 0.9,
            fontSize: 10,
          }}
        >
          {idea.commentCount || 0}
        </div>
      : null}
    </TooltipButton>
  );
};

export default ScrollToCommentsAction;
